import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import FableTooltip from "./FableTooltip";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { storyLibraryViewToggleSx } from "./StoryLibraryControls";
import { APP_TEXT_SECONDARY } from "../createShared";

const arrowSx = { ...storyLibraryViewToggleSx(false), "&.Mui-disabled": { color: "rgba(255,255,255,0.32)", bgcolor: "#1B1E28", opacity: 1 } };

/** Controls consume page metadata, so a service cursor can replace local paging. */
export default function CollectionPagination({ label, range, hasPrevious, hasNext, loading = false, onPrevious, onNext }: {
  label: string; range: string; hasPrevious: boolean; hasNext: boolean; loading?: boolean;
  onPrevious: () => void; onNext: () => void;
}) {
  return <Box component="nav" aria-label={`${label} pagination`} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1, flexWrap: "wrap" }}>
    <Typography role="status" fontSize={12} color={APP_TEXT_SECONDARY} sx={{ mr: 0.5 }}>{range}</Typography>
    <FableTooltip title="Previous page"><span><IconButton aria-label={`Previous ${label.toLowerCase()}`} disabled={loading || !hasPrevious}
      onClick={onPrevious} sx={arrowSx}><ChevronLeft /></IconButton></span></FableTooltip>
    <FableTooltip title="Next page"><span><IconButton aria-label={`Next ${label.toLowerCase()}`} disabled={loading || !hasNext}
      onClick={onNext} sx={arrowSx}><ChevronRight /></IconButton></span></FableTooltip>
  </Box>;
}
